var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3275 0C5.97523 0 -0.00585938 5.98109 -0.00585938 13.3333C-0.00585938 20.6856 5.97523 26.6667 13.3275 26.6667C20.6797 26.6667 26.6608 20.6856 26.6608 13.3333C26.6608 5.98109 20.6797 0 13.3275 0ZM17.4464 14.1189L11.8908 19.6744C11.6741 19.8911 11.3897 20 11.1052 20C10.8208 20 10.5363 19.8911 10.3197 19.6744C9.88523 19.24 9.88523 18.5378 10.3197 18.1033L15.0897 13.3333L10.3197 8.56333C9.88529 8.12891 9.88529 7.42667 10.3197 6.99224C10.7541 6.55781 11.4564 6.55781 11.8908 6.99224L17.4464 12.5478C17.8808 12.9822 17.8808 13.6844 17.4464 14.1189Z",
    fill: "#29256E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectRight);
export default __webpack_public_path__ + "static/media/select_right.a6e5e67d529c23439d396d1a39d77c48.svg";
export { ForwardRef as ReactComponent };